export const required = (value: any): boolean => typeof value !== 'undefined' && value !== null && value !== '';
